import React from 'react';
import ScreenvisionLogo from '../../../images/trailerpack_horiz_blue_bkg.png';
import classes from './Logo.module.scss';

const Logo = () => {
    return (
        <div className={classes.LogoImageContainer}>
            <img
                className={classes.LogoImage}
                src={ScreenvisionLogo}
                alt="screenvision-logo" />
        </div>
    );
}

export default Logo;